import { ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import CloseIcon from './CloseIcon'
import { useMFContext } from 'components/MFHelpers/MFContext'

interface Municipality {
  ORTNAME: string
  PLZ4: number
  PLZ6: number
  GDENAMK: string
  GDENR: number
  KTKZ: string
  NORMORTSNAME: string
  NORMGEMEINDE: string
}
const ToolTip: React.FC<{
  activeData: any
  currentName?: string
  propertyName?: string
  isClosable?: boolean
  hasShadow?: boolean
  closePressed?: () => void
}> = ({
  activeData,

  isClosable,
  hasShadow,
  closePressed,
}): ReactElement => {
  const { _t } = useMFContext()
  return (
    <TooltipContainer>
      <Row>
        <div className='tooltip-title'>
          <b>{activeData.Gemeinde}</b>
        </div>
      </Row>
      <Row>
        <div>{_t("solar_count")}:</div>
        <div>{activeData.CumNumberPlants}</div>
      </Row>
      <Row>
        <div>{_t("total_production")}:</div>
        <div>{activeData.CumTotalProductionGWh} GWh</div>
      </Row>
      <Row>
        <div>{_t("total_potential")}:</div>
        <div>{activeData.TotalPotentialProductionGWh} GWh</div>
      </Row>
      <Row>
        <div>
          <b>{_t("effective_potential")}:</b>
        </div>
        <div>
          <b>{activeData.CumEffectivePotentialUsed} %</b>
        </div>
      </Row>
    </TooltipContainer>
  )
}
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const TooltipContainer = styled.div`
  background-color: var(--site-background);
  padding: 15px;
  font-size: 14px;
  min-width: 330px;
  .tooltip-title {
    font-size: 18px;
    font-weight: bold;
  }
`

export default ToolTip
